<template>
  <div>
    <Header
      class="yh-header"
      active="/"
      :show-menu="false"
      :enable-top="true"
    />
    <!-- <div style="height: 70px"></div> -->

    <div :style="`background: black; transform: matrix(1, 0, 0, 1, 0, ${f});`">
      <HomeBanner
        class="yh-main"
        :style="`opacity: ${opacity};`"
      />
    </div>

    <HomeMenu class="yh-main" />
    <HomeLiquor />
    <HomeBaike
      class="yh-main"
      :list="indexData.productBaseList"
      :count="indexData.productBaseCount"
    />
    <HomeService2
      class="yh-main"
      :list="indexData.commodityMarketingList.slice(0, 4)"
      :count="indexData.commodityMarketingCount"
    />
    <HomeOvop
      class="yh-main"
      :list="indexData.oneVillageOneProductList"
      :count="indexData.oneVillageOneProductCount"
    />
    <HomeFooter class="yh-footer" />
    <HomeCopyright />
  </div>
</template>

<script>
import Header from '@/components/Header'
import HomeBanner from '@/components/index/HomeBanner'
import HomeMenu from '@/components/index/HomeMenu'
import HomeBaike from '@/components/index/HomeBaike'
import HomeService2 from '@/components/index/HomeService2'
import HomeOvop from '@/components/index/HomeOvop'
import HomeFooter from '@/components/index/HomeFooter'
import HomeCopyright from '@/components/index/HomeCopyright'
import HomeLiquor from '@/components/index/HomeLiquor'

export default {
  name: 'Index',
  components: {
    Header,
    HomeBanner,
    HomeMenu,
    HomeBaike,
    HomeService2,
    HomeOvop,
    HomeFooter,
    HomeCopyright,
    HomeLiquor
  },
  data() {
    return {
      scrollTop: 0,
      indexData: {
        productBaseList: [],
        productBaseCount: 0,
        commodityMarketingList: [],
        commodityMarketingCount: 0,
        oneVillageOneProductList: [],
        oneVillageOneProductCount: 0
      }
    }
  },

  computed: {
    f() {
      return -this.scrollTop / 4
    },
    opacity() {
      return (500 - this.scrollTop) / 500
    }
  },
  async created() {
    window.addEventListener('scroll', this.handleScroll, true)

    const indexData = await this.ajax.doPost({
      packageName: 'index',
      className: 'index',
      methodName: 'index',
      params: {}
    })

    // console.log(indexData);

    this.indexData = indexData

    this.ajax.doPost({
      packageName: 'user',
      className: 'userAnalysis',
      methodName: 'create',
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: '首页',
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    })
  },
  methods: {
    handleScroll(e) {
      this.scrollTop = e.target.documentElement && e.target.documentElement.scrollTop
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
